import { GENDER } from '@vindr/services/constants/common.constant';

export const GENDER_OPTIONS = [
  { label: 'Male', value: GENDER.Male },
  { label: 'Female', value: GENDER.Female },
  { label: 'Other', value: GENDER.Other },
];
